import { ANEXOS_SCHEMA_TCE, isMenorDeIdade } from "../utils.js";

export const CAMPOS_SEMPRE_OPCIONAIS_TCE = [
  "observacoes1",
  "observacoes2",
  "empresa_id",
  "termino_estagio_autopreenchido",
  "local_estagio_editado",
  "horarioFixo",
  "horariosAlternados",
  "horario_fixo_ou_alternado",
  "maior_menor_idade",
  "nome_telefone_estudante_aprovado",
  "estudanteaprovadofoiindicadooucaptado",
  "contrato_confeccionado",
  "data_confeccao",
  "usuario_confeccao_id",
  "usuario_confeccao_nome",
  "contrato_disponibilizado",
  "data_disponibilizacao",
  "usuario_disponibilizacao_id",
  "usuario_disponibilizacao_nome",
  "data_conclusao",
  "usuario_conclusao_id",
  "usuario_conclusao_nome",
  "validador_id",
  "atribuido_em",
  "anexo_carteira_path",
  "anexo_carteira_nome",
  "anexo_cartao_cnpj_path",
  "anexo_cartao_cnpj_nome",
  "anexo_contrato_social_path",
  "anexo_contrato_social_nome",
  "anexo_declaracao_escolar_path",
  "anexo_declaracao_escolar_nome",
  "anexo_declaracao_carga_horaria_path",
  "anexo_declaracao_carga_horaria_nome",
  "anexo_documento_identificacao_path",
  "anexo_documento_identificacao_nome",
  "contratoConfeccionado",
  "dataConfeccao",
  "usuarioConfeccaoId",
  "usuarioConfeccaoNome",
  "contratoDisponibilizado",
  "dataDisponibilizacao",
  "usuarioDisponibilizacaoId",
  "usuarioDisponibilizacaoNome",
  "dataConclusao",
  "usuarioConclusaoId",
  "usuarioConclusaoNome",
  "validadorId",
  "atribuidoEm",
];

export const CAMPOS_CONTROLE_INTERNO_PREFIXOS = [
  "confecc",
  "confeccion",
  "disponibiliz",
  "conclus",
  "atribuido",
  "validador",
  "anexo_",
  "usuario_",
];

export const CAMPOS_SOMENTE_EMPRESA = [
  "empresa",
  "cnpj_cpf",
  "telefones",
  "email_empresa",
  "local_realizacao_atividades",
  "nome_termo_compromisso",
  "email",
  "nome",
  "cargo_estagiario",
  "cpf_estagiario",
  "formacao_escolar",
  "email_supervisor",
  "inicio_estagio",
  "termino_estagio",
  "valor_bolsa_auxilio",
  "valor_bolsa_transporte",
  "local_estagio",
  "atividades_desenvolvidas",
  "tipo_contrato",
];

export const CAMPOS_SOMENTE_ESTUDANTE = [
  "origem_candidato",
  "cpf_estudante_estagiario",
  "nome_estagiario",
  "telefone_estagiario",
  "email_estagiario",
  "nome_menor_idade",
  "email_menor_idade",
  "telefone_menor_idade",
  "cpf_menor_idade",
  "escola",
  "unidade",
  "curso",
  "ano_periodo_serie",
  "previsao_formatura",
  "tipo_estagio",
  "orientador_estagio",
  "cargo",
  "email_escola",
  "cnpj_escola",
  "turno",
];

export const CAMPOS_FILIAL_TCE = [
  "nome_filial",
  "cpfCnpj",
  "cepFilial",
  "enderecoFilial",
  "bairro",
  "municipio",
  "uf",
  "emailContratos",
  "emailFinanceiro",
  "representadaPor",
  "cargoRepresentante",
  "emailRepresentante",
  "responsavelSupervisor",
  "cargoSupervisor",
  "emailSupervisor",
  "telefones2",
];

export const CAMPOS_MENOR_IDADE_TCE = [
  "nome_menor_idade",
  "email_menor_idade",
  "telefone_menor_idade",
  "cpf_menor_idade",
];

export const CAMPOS_OBRIGATORIOS_EMPRESA_BASE = [
  "origem_candidato",
  "empresa",
  "cnpj_cpf",
  "telefones",
  "email_empresa",
  "nome_termo_compromisso",
  "email",
  "nome",
  "cargo_estagiario",
  "cpf_estagiario",
  "formacao_escolar",
  "email_supervisor",
  "inicio_estagio",
  "termino_estagio",
  "valor_bolsa_auxilio",
  "valor_bolsa_transporte",
  "local_estagio",
  "atividades_desenvolvidas",
  "tipo_contrato",
];

export const ROTULOS_CAMPOS_TCE = {
  origem_candidato: "Origem do Candidato",
  empresa: "Razão Social",
  cnpj_cpf: "CNPJ/CPF",
  telefones: "Telefone",
  email_empresa: "E-mail da Empresa",
  nome_termo_compromisso: "Nome de quem assina o Termo de Compromisso",
  email: "E-mail de quem assina o Termo de Compromisso",
  nome: "Nome do Supervisor",
  cargo_estagiario: "Cargo do Supervisor",
  cpf_estagiario: "CPF do Supervisor",
  formacao_escolar: "Formação Escolar do Supervisor",
  email_supervisor: "E-mail do Supervisor",
  inicio_estagio: "Início do Estágio",
  termino_estagio: "Término do Estágio",
  valor_bolsa_auxilio: "Valor da Bolsa Auxílio",
  valor_bolsa_transporte: "Valor do Auxílio Transporte",
  local_estagio: "Local do Estágio",
  atividades_desenvolvidas: "Atividades Desenvolvidas",
  tipo_contrato: "Tipo de Contrato",
  nome_filial: "Nome da Filial",
  cpfCnpj: "CNPJ/CPF da Filial",
  cepFilial: "CEP da Filial",
  enderecoFilial: "Endereço da Filial",
  bairro: "Bairro da Filial",
  municipio: "Município da Filial",
  uf: "UF da Filial",
  emailContratos: "E-mail Contrato da Filial",
  emailFinanceiro: "E-mail Financeiro da Filial",
  representadaPor: "Representante da Filial",
  cargoRepresentante: "Cargo do Representante",
  emailRepresentante: "E-mail do Representante",
  responsavelSupervisor: "Responsável/Supervisor",
  cargoSupervisor: "Cargo do Supervisor",
  emailSupervisor: "E-mail do Supervisor",
  telefones2: "Telefone 2 da Filial",
  nome_estagiario: "Nome do Estagiário",
  cpf_estudante_estagiario: "CPF do Estagiário",
  estudante_id: "Estudante",
  nome_menor_idade: "Nome do Responsável Legal",
  email_menor_idade: "E-mail do Responsável Legal",
  telefone_menor_idade: "Telefone do Responsável Legal",
  cpf_menor_idade: "CPF do Responsável Legal",
  escola: "Escola/Faculdade",
  unidade: "Unidade",
  curso: "Curso",
  ano_periodo_serie: "Ano, período ou série",
  previsao_formatura: "Previsão de Formatura",
  turno: "Turno",
  tipo_estagio: "Tipo de Estágio",
  orientador_estagio: "Orientador de Estágio",
  cargo: "Cargo do Orientador",
  email_escola: "E-mail da Escola",
  cnpj_escola: "CNPJ da Escola",
};

export const isEmptyValue = (v) => {
  if (v === null || v === undefined) return true;
  if (typeof v === "string" && v.trim() === "") return true;
  return false;
};

export const isCampoControleInterno = (campo) => {
  if (typeof campo !== "string") return false;
  if (CAMPOS_SEMPRE_OPCIONAIS_TCE.includes(campo)) return true;
  const lower = campo.toLowerCase();
  return CAMPOS_CONTROLE_INTERNO_PREFIXOS.some((p) => lower.includes(p));
};

export const getAnexosObrigatoriosFaltandoTce = (
  anexosFiles = {},
  isEstudante = false,
  schema = ANEXOS_SCHEMA_TCE,
) => {
  if (!isEstudante) return [];
  return schema.filter((doc) => doc.required && !anexosFiles[doc.id]);
};

export const validarCamposObrigatoriosTce = ({
  formData = {},
  isEstudante = false,
  idadeCalculada = null,
  anexosFiles = {},
  schema = ANEXOS_SCHEMA_TCE,
} = {}) => {
  if (isEstudante) {
    const camposFaltando = [];
    if (isMenorDeIdade(idadeCalculada)) {
      CAMPOS_MENOR_IDADE_TCE.forEach((c) => {
        if (isEmptyValue(formData[c])) {
          camposFaltando.push(c);
        }
      });
    }
    const anexosFaltando = schema.filter(
      (doc) => doc.required && !anexosFiles[doc.id],
    );
    return { camposFaltando, anexosFaltando };
  }

  const camposFaltando = [];

  CAMPOS_OBRIGATORIOS_EMPRESA_BASE.forEach((c) => {
    if (isEmptyValue(formData[c])) {
      camposFaltando.push(c);
    }
  });

  if (formData.origem_candidato === "CIEEMG" && isEmptyValue(formData.estudante_id)) {
    camposFaltando.push("estudante_id");
  }

  if (formData.origem_candidato === "EMPRESA") {
    if (isEmptyValue(formData.nome_estagiario)) {
      camposFaltando.push("nome_estagiario");
    }
    if (isEmptyValue(formData.cpf_estudante_estagiario)) {
      camposFaltando.push("cpf_estudante_estagiario");
    }
  }

  if (formData.local_realizacao_atividades === "FILIAL") {
    CAMPOS_FILIAL_TCE.forEach((c) => {
      if (isEmptyValue(formData[c])) {
        camposFaltando.push(c);
      }
    });
  }

  // Nota: Os campos de Responsável Legal (CAMPOS_MENOR_IDADE_TCE) são de
  // preenchimento exclusivo do estudante/aprendiz menor de idade na etapa dele
  // (isEstudante === true) e ficam bloqueados para a empresa no cadastro inicial.

  const anexosFaltando = [];

  return { camposFaltando, anexosFaltando };
};

export const filtrarCamposFaltandoPorPapel = (lista, isEstudante) => {
  if (!Array.isArray(lista)) return [];
  if (isEstudante) return lista;
  return lista.filter(
    (c) => !CAMPOS_SOMENTE_ESTUDANTE.includes(String(c || "")),
  );
};
